import { NOTIFICATION_PRIORITIES } from './FormHeader.constants'

function notificationsComparator(notification1, notification2) {
  return (
    NOTIFICATION_PRIORITIES[notification2.type] -
    NOTIFICATION_PRIORITIES[notification1.type]
  )
}

export function getSortedNotifications(notifications) {
  return [...notifications.sort(notificationsComparator)]
}
